module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image10-5ee3b1b7753752853eb652047fea5337.jpg";